/* eslint-disable */
export default {
  /**
   * Checks breakpoint by window width
   * 
   * @returns {string}
   */
  checkBreakpoint () {
    if (window.innerWidth >= 1280) {
      return 'xl'
    } else if (window.innerWidth >= 992) {
      return 'lg'
    } else if (window.innerWidth >= 768) {
      return 'md'
    } else if (window.innerWidth >= 480) {
      return 'sm'
    } else {
      return 'xs'
    }
  },
  /**
   * Checks if you are on a mobile device
   * 
   * @returns {boolean}
   */
  isMobile () {
    if (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true
    } else {
      return false
    }
  },
  /**
   * Checks if you are on an Apple device
   * 
   * @returns {boolean}
   */
  isIOS () {
    return navigator.userAgent.match(/iPad|iPod|iPhone/i)
  },
  /**
   * Checks if you are on an IE browser
   *
   * @returns {boolean}
   */
  isIE () {
    return navigator.userAgent.match(/MSIE/i) || navigator.userAgent.match(/Trident/i)
  },
  /**
   * Creates a randomly generated string to use as a GUID
   * 
   * @returns {string}
   */
  createGuid: function () {
    'use strict';
    function _p8(s) {
      var p = (Math.random().toString(16) + '000000000').substr(2, 8);
      return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
    }

    return _p8() + _p8(true) + _p8(true) + _p8();
  },
  /**
   * Generate random alpha numberic string
   * 
   * @param {int} count 
   * @returns {string}
   */
  randomAlphaNumberic (count = 32) {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (var i = 0; i < count; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  },
  /**
   * Not sure what this is for
   * 
   * @param {string} url 
   * @param {function} callback 
   */
  imgToBase64 (url, callback) {
    let image = new Image()

    image.onload = function () {
      let canvas = document.createElement('canvas')

      canvas.width = this.naturalWidth
      canvas.height = this.naturalHeight
      canvas.getContext('2d').drawImage(this, 0, 0)

      // callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''))

      callback(canvas.toDataURL('image/png'))
    }

    image.src = url

    image.onerror = function (error) {
      console.log(error)
    }
  },
  /**
   * Throttle things
   * 
   * @param {object} context 
   * @param {function} func 
   * @param {int} wait 
   * @param {boolean} immediate 
   */
  debounce (context, func, wait, immediate) {
    let args = arguments
    let later = () => {
      context.timeout = null
      if (!immediate) func.apply(context, args)
    }
    let callNow = immediate && !context.timeout
    clearTimeout(context.timeout)
    context.timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  },
  /**
   * Yet another method to randomly generate a string
   * 
   * @returns {string}
   */
  generateUniqueKey () {
    return '_' + Math.random().toString(36).substr(2, 9)
  },
  /**
   * Truncates text within an element
   * 
   * @param {object} target 
   * @param {number} maxHeight 
   */
  truncate (target, maxHeight) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!maxHeight) return;
    var els = typeof target === 'string' ? document.querySelectorAll(target) : target;
    if (!els) return;

    var character = opts.character || '…';
    var classname = opts.classname || 'js-shave';
    var spaces = opts.spaces || true;
    var charHtml = '<span class="js-shave-char">' + character + '</span>';

    if (!('length' in els)) els = [els];
    for (var i = 0; i < els.length; i += 1) {
      var el = els[i];
      var styles = el.style;
      var span = el.querySelector('.' + classname);
      var textProp = el.textContent === undefined ? 'innerText' : 'textContent';

      // If element text has already been shaved
      if (span) {
        // Remove the ellipsis to recapture the original text
        el.removeChild(el.querySelector('.js-shave-char'));
        el[textProp] = el[textProp]; // nuke span, recombine text
      }

      var fullText = el[textProp];
      var words = spaces ? fullText : fullText.split(' ');

      // If 0 or 1 words, we're done
      if (words.length < 2) continue;

      // Temporarily remove any CSS height for text height calculation
      var heightStyle = styles.height;
      styles.height = 'auto';
      var maxHeightStyle = styles.maxHeight;
      styles.maxHeight = 'none';

      // If already short enough, we're done
      if (el.offsetHeight <= maxHeight) {
        styles.height = heightStyle;
        styles.maxHeight = maxHeightStyle;
        continue;
      }

      // Binary search for number of words which can fit in allotted height
      var max = words.length - 1;
      var min = 0;
      var pivot = void 0;
      while (min < max) {
        pivot = min + max + 1 >> 1; // eslint-disable-line no-bitwise
        el[textProp] = spaces ? words.slice(0, pivot) : words.slice(0, pivot).join(' ');
        el.insertAdjacentHTML('beforeend', charHtml);
        if (el.offsetHeight > maxHeight) max = spaces ? pivot - 2 : pivot - 1;else min = pivot;
      }

      el[textProp] = spaces ? words.slice(0, max) : words.slice(0, max).join(' ');
      el.insertAdjacentHTML('beforeend', charHtml);
      var diff = spaces ? words.slice(max) : words.slice(max).join(' ');

      el.insertAdjacentHTML('beforeend', '<span class="' + classname + '" style="display:none;">' + diff + '</span>');

      styles.height = heightStyle;
      styles.maxHeight = maxHeightStyle;
    }
  },
  /**
   * Provides a way to parse a url
   * 
   * @param {string} url 
   * @returns {object}
   */
  parseURL (url) {
    let parser = document.createElement('a')
    parser.href = url
    return parser
  },
  /**
   * Returns url without query string
   * 
   * @param {*} url 
   * @returns {string}
   */
  newImageSize (url) {
    let thumb = this.parseURL(url)
    return thumb.origin + thumb.pathname
  }
}
